import React, { useState } from "react";
import { registerMember } from "../api//memberApi";
import paymentscanner from "../assets/paymentscanner.jpeg";

const MembershipPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    gender: "",
    aadhaarNo: "",
    panNumber: "",
    caste: "",
    state: "",
    address: "",
    phone: "",
    email: "",
     memberType: "",

  no_of_shares: "",
  });

  const [aadhaarDoc, setAadhaarDoc] = useState(null);
  const [paymentScreenshot, setPaymentScreenshot] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});

  // Handle input
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Live validation: clear error once corrected
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  // Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    // Basic validation
    if (
      !formData.name ||
      !formData.gender ||
      !formData.aadhaarNo ||
      !formData.panNumber ||
      !formData.caste ||
      !formData.state ||
      !formData.address ||
      !formData.phone ||
      !formData.email || !formData.memberType || !formData.no_of_shares
    ) {
      setMessage("Please fill in all required fields.");
      setLoading(false);
      return;
    }

    if (!/^\d{12}$/.test(formData.aadhaarNo)) {
      setMessage("Invalid Aadhaar number. It must be 12 digits.");
      setLoading(false);
      return;
    }

    if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      setMessage("Invalid phone number.");
      setLoading(false);
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setMessage("Invalid email address.");
      setLoading(false);
      return;
    }

    if (Number(formData.no_of_shares) < 1) {
  setMessage("Please select a membership type and at least 1 share.");
  setLoading(false);
  return;
}

    const data = new FormData();
    Object.keys(formData).forEach((key) => data.append(key, formData[key]));
    if (aadhaarDoc) data.append("aadhaarDoc", aadhaarDoc);
    if (paymentScreenshot) data.append("paymentScreenshot", paymentScreenshot);

    try {
      const res = await registerMember(data);
      setMessage(res.message || "Member registered successfully.");
      setFormData({
        name: "",
        gender: "",
        aadhaarNo: "",
        panNumber: "",
        caste: "",
        state: "",
        address: "",
        phone: "",
        email: "",
        memberType:"",

        no_of_shares:""
      });
      setAadhaarDoc(null);
      setPaymentScreenshot(null);
    } catch (err) {
      setMessage(err.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-h-screen bg-white text-primary py-20 px-4 md:px-16 lg:px-28 mt-24 md:mt-40">
      {/* Header Section */}
      <div className="text-center mb-14">
        <h1 className="text-3xl md:text-5xl font-bold text-accent tracking-wide">
          <span className="text-primary"> Membership </span> & Admission Fees
        </h1>
        <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
          Join{" "}
          <span className="font-semibold text-primary">
            Jeeva Shakthi Housing Multistate Cooperative Society Ltd.
          </span>{" "}
          and become part of a trusted cooperative movement fostering growth and
          opportunity.
        </p>
      </div>

      {/* Membership Type Section */}
<div className="grid md:grid-cols-3 gap-10 mb-16">

  {/* Ordinary Members */}
  <div className="bg-gradient-to-br from-accent/10 to-accent/5 border border-accent/20 shadow-lg rounded-2xl p-8 hover:shadow-xl transition">
    <h2 className="text-2xl font-semibold text-primary mb-4">
      Ordinary <span className="text-accent">Members</span>
    </h2>
    <p className="text-gray-700 text-lg leading-relaxed mb-3">
      Admission Fee: <span className="font-bold text-accent">Rs. 100/- only</span>
    </p>
    <p className="text-gray-600 text-sm">
      Ordinary Members       <span className="font-semibold text-accent">can vote</span> and participate for Board elections. </p>
  </div>

  {/* Nominal / Associate Members */}
  <div className="bg-gradient-to-br from-accent/10 to-accent/5 border border-accent/20 shadow-lg rounded-2xl p-8 hover:shadow-xl transition">
    <h2 className="text-2xl font-semibold text-primary mb-4">
      Nominal / <span className="text-accent">Associate Members</span>
    </h2>
    <p className="text-gray-700 text-lg leading-relaxed mb-3">
      Admission Fee: <span className="font-bold text-accent">Rs. 100/- only</span>
    </p>
    <p className="text-gray-600 text-sm">
      Nominal / Associate Members
      are <span className="font-semibold text-accent">not permitted</span> to vote and participate for Board elections.
    

    </p>
  </div>

  {/* Co-operative Share Card */}
  <div className="bg-gradient-to-br from-accent/10 to-accent/5 border border-accent/20 shadow-lg rounded-2xl p-8 hover:shadow-xl transition">
    <h2 className="text-2xl font-semibold text-primary mb-4">
      Cooperative <span className="text-accent">Shares </span>
    </h2>
    <p className="text-gray-700 text-lg leading-relaxed mb-3">
      Share Price: <span className="font-bold text-accent">Rs. 100 / share</span>
    </p>
    <p className="text-gray-600 text-sm mb-3">
      Minimum 1 share purchase is <span className="font-semibold text-accent">mandatory</span> for membership approval.
    </p>
  
  </div>

</div>


      {/* Procedure Section */}
      <div className="bg-white shadow-xl rounded-3xl border border-accent/10 p-8 md:p-12 mb-14">
        <h2 className="text-2xl md:text-3xl font-bold text-primary mb-6">
          Procedure for Obtaining{" "}
          <span className=" text-accent"> Membership</span>
        </h2>
        <p className="text-gray-700 leading-relaxed text-lg mb-6">
          <span className="font-semibold text-accent">
            (As per Rule 11(a) & Rule 11(c) of MSCS Rules 2002)
          </span>
        </p>

        <ul className="list-decimal ml-6 text-gray-700 text-lg space-y-3 leading-relaxed">
          <li>
            The application for membership of the society shall be
            submitted by an applicant to the Chief Executive of the society in
            prescribed form.
          </li>
          <li>
            The form must be accompanied by full payment of the{" "}
            <span className="font-semibold text-accent">
              admission/membership fee of Rs. 100/-
            </span>{" "}
            and value of minimum one share of{" "}
            <span className="font-semibold text-accent">Rs. 100/-</span>.
          </li>
          <li>
            The society shall process the application in accordance with the
            rules and communicate the decision to the applicant within the
            stipulated time.
          </li>
        </ul>
      </div>

      {/* Disposal Section */}
      <div className="bg-accent/5 border border-accent/20 shadow-md rounded-3xl p-8 md:p-12">
        <h2 className="text-2xl md:text-3xl font-bold text-primary mb-6">
          Disposal of <span className=" text-accent"> Applications</span>
        </h2>
        <p className="text-gray-700 text-lg leading-relaxed mb-4">
          Applications for Ordinary Membership complete in all respects shall be
          disposed of within{" "}
          <span className="font-semibold text-accent">four months</span> from
          the date of receipt by the society.
        </p>
        <p className="text-gray-700 text-lg leading-relaxed mb-4">
          The decision shall be communicated to the applicant within{" "}
          <span className="font-semibold text-accent">fifteen days</span> of the
          decision by Registered Post.
        </p>
        <p className="text-gray-700 text-lg leading-relaxed">
          If not disposed within the period specified, or the decision is not
          communicated within fifteen days of the expiry of four months, it
          shall be deemed that the society has refused the admission.{" "}
          <span className="font-semibold text-accent">
            Admission/Membership fee shall not be refundable in any case.
          </span>
        </p>
      </div>

{/* Housing Scheme Details Section - Attractive & Themed */}
<div className="bg-white shadow-2xl rounded-3xl border-2 border-primary/20 p-8 md:p-12 mb-16 mt-12">
  {/* Main Header */}
  <h2 className="text-3xl md:text-4xl font-extrabold text-primary mb-8 text-center border-b-2 border-accent/50 pb-4">
    <span className="text-accent">House Construction</span> Scheme
  </h2>

  {/* Key Benefits Card */}
  <div className="bg-primary/5 p-6 rounded-xl shadow-inner mb-8">
    <h3 className="text-xl font-bold text-accent mb-4">✨ Key Scheme Benefits</h3>
    <ul className="list-disc ml-6 text-gray-700 text-lg space-y-3 leading-relaxed">
      <li>Construction works at much <span className="font-bold text-primary">lower prices</span> than market rate.</li>
      <li><span className="font-bold text-accent">Bank loans directly arranged</span> through the co-operative society.</li>
      <li>Assistance in obtaining electricity connection.</li>
      <li>Arranges <span className="font-bold text-primary">DTCP (planning) approval</span> through official letters.</li>
    </ul>
  </div>

  {/* Planning Fees */}
  <div className="mb-8">
    <h3 className="text-2xl font-bold text-primary mb-4">💰 Fees for Planning Permission</h3>
    <ul className="list-disc ml-6 text-gray-700 text-lg space-y-2 leading-relaxed">
      <li>Land Development Charges</li>
      <li>Building Development Charges</li>
      <li>Regularization Charges: <span className="font-extrabold text-accent">₹1,000</span></li>
      <li>O.S.R. Charges, Additional Fees, etc.</li>
      <li>Panchayat Union Fees, Inspection Fees, Plan Copy, etc.</li>
      <li>Flag Day Fund (DD in favor of "Armed Force Flag Day Fund")</li>
      <li>
        <span className="font-bold text-primary">Total Payment:</span> <span className="font-extrabold text-accent">₹18,000</span> to be paid within <span className="font-bold text-primary">10 days</span> for building plan approval.
      </li>
    </ul>
  </div>
  
  <hr className="my-8 border-accent/20"/>

  {/* House Construction Subsidies */}
  <div className="mb-8">
    <h3 className="text-2xl font-bold text-primary mb-4">🏠 Subsidy for House Construction</h3>
    <ul className="list-disc ml-6 text-gray-700 text-lg space-y-2 leading-relaxed">
      <li>PMAY - Govt Subsidy of <span className="font-extrabold text-accent">₹2.67 lakhs</span>.</li>
      <li>Jeeva Shakthi Housing provides an <span className="font-extrabold text-primary">additional 10% subsidy</span>.</li>
      <li><span className="font-bold text-accent">100% Income Tax Exemption</span></li>
      <li>Share in Profits each year</li>
    </ul>
  </div>

  {/* Solar Plan Subsidies Table */}
 {/* Prime Minister’s Solar Home Free Electricity Plan Table - Mobile Optimized */}
<div className="overflow-x-auto rounded-lg border border-primary/30 mb-8">
    <table className="min-w-full text-left text-gray-700 border-collapse">
        <thead>
            <tr className="bg-primary text-white">
                <th className="px-4 py-3 border border-primary/30">Power</th>
                <th className="px-4 py-3 border border-primary/30">Govt Solar Subsidy</th>
                <th className="px-4 py-3 border border-primary/30">Jeeva Shakthi Subsidy</th>
                <th className="px-4 py-3 border border-primary/30">Total Subsidy</th>
            </tr>
        </thead>
        <tbody>
            <tr className="hover:bg-accent/5">
                <td className="px-4 py-3 border border-primary/30 font-semibold">1 kW</td>
                <td className="px-4 py-3 border border-primary/30">₹30,000</td>
                <td className="px-4 py-3 border border-primary/30">₹7,500</td>
                <td className="px-4 py-3 border border-primary/30 font-extrabold text-accent">₹37,500</td>
            </tr>
            <tr className="bg-primary/5 hover:bg-accent/10">
                <td className="px-4 py-3 border border-primary/30 font-semibold">2 kW</td>
                <td className="px-4 py-3 border border-primary/30">₹60,000</td>
                <td className="px-4 py-3 border border-primary/30">₹15,000</td>
                <td className="px-4 py-3 border border-primary/30 font-extrabold text-accent">₹75,000</td>
            </tr>
            <tr className="hover:bg-accent/5">
                <td className="px-4 py-3 border border-primary/30 font-semibold">3 kW or more</td>
                <td className="px-4 py-3 border border-primary/30">₹78,000</td>
                <td className="px-4 py-3 border border-primary/30">₹22,000</td>
                <td className="px-4 py-3 border border-primary/30 font-extrabold text-accent">₹100,000</td>
            </tr>
        </tbody>
    </table>
</div>

  
  <hr className="my-8 border-accent/20"/>

  {/* Grocery Subsidy */}
  <div className="mb-8">
    <h3 className="text-2xl font-bold text-primary mb-4">🛒 Monthly Grocery Subsidy</h3>
<p className="text-gray-700 text-lg leading-relaxed">
  For members who have constructed their homes through our 
  <span className="text-accent font-semibold"> Jeeva Shakti Housing Multistate Cooperative Society</span>, 
  monthly groceries will be provided directly from the 
  <span className="text-accent font-semibold"> Consumer Supermarket and Sales Cooperative Society&nbsp;</span> 
  as <span className="text-primary font-semibold">subsidy for up to five years</span>.
</p> </div>

  {/* CLSS Table */}
  <div className="mb-8">
   
<h3 className="text-2xl font-bold text-primary mb-4">🏦 CLSS - Credit Linked Subsidy Scheme</h3>
{/* CLSS Table - Mobile Optimized */}
<div className="overflow-x-auto rounded-lg border border-primary/30">
    <table className="min-w-full text-left text-gray-700 border-collapse">
        <thead>
            <tr className="bg-primary text-white">
                <th className="px-4 py-3 border border-primary/30">Income Group</th>
                <th className="px-4 py-3 border border-primary/30">Annual Income</th>
                <th className="px-4 py-3 border border-primary/30">Interest Subsidy Rate</th>
                <th className="px-4 py-3 border border-primary/30">Subsidy Value</th>
            </tr>
        </thead>
        <tbody>
            <tr className="hover:bg-accent/5">
                <td className="px-4 py-3 border border-primary/30 font-semibold">EWS/LIG (incl. SC/ST)</td>
                <td className="px-4 py-3 border border-primary/30">Up to ₹6 lakhs</td>
                <td className="px-4 py-3 border border-primary/30"><span className="font-extrabold text-accent">6.5%</span> (for ₹6 lakhs loan)</td>
                <td className="px-4 py-3 border border-primary/30 font-extrabold text-accent">₹2.2 – 2.67 lakhs</td>
            </tr>
            <tr className="bg-primary/5 hover:bg-accent/10">
                <td className="px-4 py-3 border border-primary/30 font-semibold">MIG-I</td>
                <td className="px-4 py-3 border border-primary/30">₹6 lakhs – ₹12 lakhs</td>
                <td className="px-4 py-3 border border-primary/30"><span className="font-extrabold text-accent">4%</span> (for ₹9 lakhs loan)</td>
                <td className="px-4 py-3 border border-primary/30 font-extrabold text-accent">₹2.35 lakhs</td>
            </tr>
            <tr className="hover:bg-accent/5">
                <td className="px-4 py-3 border border-primary/30 font-semibold">MIG-II</td>
                <td className="px-4 py-3 border border-primary/30">₹12 lakhs – ₹18 lakhs</td>
                <td className="px-4 py-3 border border-primary/30"><span className="font-extrabold text-accent">3%</span> (for ₹12 lakhs loan)</td>
                <td className="px-4 py-3 border border-primary/30 font-extrabold text-accent">₹2.30 lakhs</td>
            </tr>
        </tbody>
    </table>
</div>
  </div>
  
  <hr className="my-8 border-accent/20"/>

  {/* Special Scheme for SC/ST */}
  <div className="bg-accent/5 p-6 rounded-xl shadow-md border border-accent/30 mb-8">
    <h3 className="text-2xl font-bold text-accent mb-4">⭐ Special Scheme for Adi Dravidar and Tribal Welfare</h3>
    <ul className="list-disc ml-6 text-gray-700 text-lg space-y-2 leading-relaxed">
      <li>Financial support for new houses for <span className="font-bold text-primary">SC/ST families</span> with no land or house.</li>
      <li>Quantum of support: <span className="font-extrabold text-primary">₹2 lakhs to ₹4 lakhs</span>.</li>
      <li><span className="font-bold text-accent">Full grant—no repayment necessary. (for subsidy)</span></li>
      <li>Priority to widows, destitute women and laborers.</li>
    </ul>
  </div>

  {/* Additional Benefits Footer */}
  <div className="pt-4 text-center">
    <p className="text-xl font-bold text-primary mb-2">
      Plus, get Extra Benefits from <span className="text-accent">Adi Dravidar and Tribal Co-operative Society!</span>
    </p>
    <p className="text-lg text-gray-600">
      <span className="font-extrabold text-accent">KAHI Housing Multi-State Co-operative Society</span> – Extra <span className="font-extrabold text-primary">20% benefits</span>.
    </p>
  </div>
</div>

      {/* Member Registration Form Section */}
      <div className="mt-16 bg-gradient-to-br from-accent/10 to-accent/5 border border-accent/20 shadow-xl rounded-3xl p-8 md:p-12">
        <h2 className="text-2xl md:text-3xl font-bold text-primary mb-6 text-center">
          Member <span className="text-accent">Registration Form</span>
        </h2>
        <p className="text-center text-gray-600 mb-8 max-w-2xl mx-auto text-lg">
          Fill out the form below to apply for membership in the{" "}
          <span className="font-semibold text-accent">
            Jeeva Shakthi Housing Multistate Cooperative Society Ltd.
          </span>
        </p>

        <form
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
          onSubmit={handleSubmit}
        >
          {/* Name */}
          <div>
            <label className="block text-sm font-semibold text-primary mb-2">
              Full Name
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your full name"
              className="w-full border border-accent/30 rounded-xl px-4 py-3 focus:ring-2 focus:ring-accent/50 outline-none"
              required
            />
          </div>

          {/* Gender */}
          <div>
            <label className="block text-sm font-semibold text-primary mb-2">
              Gender
            </label>
            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              className="w-full border border-accent/30 rounded-xl px-4 py-3 focus:ring-2 focus:ring-accent/50 outline-none"
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>

          {/* Aadhaar */}
          <div>
            <label className="block text-sm font-semibold text-primary mb-2">
              Aadhaar Number
            </label>
            <input
              type="text"
              name="aadhaarNo"
              value={formData.aadhaarNo}
              onChange={handleChange}
              placeholder="Enter your Aadhaar number"
              className="w-full border border-accent/30 rounded-xl px-4 py-3 focus:ring-2 focus:ring-accent/50 outline-none"
            />
          </div>

          {/* Aadhaar Document */}
          <div>
            <label className="block text-sm font-semibold text-primary mb-2">
              Upload Aadhaar Document
            </label>
            <input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={(e) => setAadhaarDoc(e.target.files[0])}
              className="w-full border border-accent/30 rounded-xl px-4 py-2 bg-white focus:ring-2 focus:ring-accent/50 outline-none"
            />
          </div>

          {/* PAN */}
          <div>
            <label className="block text-sm font-semibold text-primary mb-2">
              PAN Number
            </label>
            <input
              type="text"
              name="panNumber"
              value={formData.panNumber}
              onChange={handleChange}
              placeholder="Enter your PAN number"
              className="w-full border border-accent/30 rounded-xl px-4 py-3 focus:ring-2 focus:ring-accent/50 outline-none"
            />
          </div>

          {/* Caste */}
          <div>
            <label className="block text-sm font-semibold text-primary mb-2">
              Caste / Community
            </label>
            <input
              type="text"
              name="caste"
              value={formData.caste}
              onChange={handleChange}
              placeholder="Enter your caste or community"
              className="w-full border border-accent/30 rounded-xl px-4 py-3 focus:ring-2 focus:ring-accent/50 outline-none"
            />
          </div>

          {/* State */}
        {/* State */}
<div>
  <label className="block text-sm font-semibold text-primary mb-2">
    State
  </label>

  <select
    name="state"
    value={formData.state}
    onChange={handleChange}
    className="w-full border border-accent/30 rounded-xl px-4 py-3 focus:ring-2 focus:ring-accent/50 outline-none"
  >
    <option value="">Select your state</option>
    <option value="Tamil Nadu">Tamil Nadu</option>
    <option value="Puducherry">Puducherry</option>
  </select>
</div>


          {/* Address */}
          <div>
            <label className="block text-sm font-semibold text-primary mb-2">
              Address
            </label>
            <textarea
              name="address"
              rows="3"
              value={formData.address}
              onChange={handleChange}
              placeholder="Enter your address"
              className="w-full border border-accent/30 rounded-xl px-4 py-3 focus:ring-2 focus:ring-accent/50 outline-none resize-none"
            ></textarea>
          </div>

          {/* Phone */}
          <div>
            <label className="block text-sm font-semibold text-primary mb-2">
              Phone Number
            </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Enter your phone number"
              className="w-full border border-accent/30 rounded-xl px-4 py-3 focus:ring-2 focus:ring-accent/50 outline-none"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-semibold text-primary mb-2">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              className="w-full border border-accent/30 rounded-xl px-4 py-3 focus:ring-2 focus:ring-accent/50 outline-none"
            />
          </div>


          {/* QR Code Section */}
          <div className="md:col-span-2 mb-6 flex flex-col items-center">
            <label className="block text-sm font-semibold text-primary mb-2">
              Scan & Pay using QR Code
            </label>

            <div className="w-full flex justify-center">
              {/* Wrap in <a> to open in new tab */}
              <a
                href={paymentscanner}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={paymentscanner}
                  alt="QR Code"
                  className="
          w-56 h-56
          md:w-64 md:h-64
          lg:w-72 lg:h-72
          object-contain
          border-4 border-accent/50
          rounded-2xl
          p-3
          bg-white
          shadow-lg
          hover:scale-105 transition-transform duration-200
          cursor-pointer
        "
                />
              </a>
            </div>

            <p className="text-center text-sm mt-3 text-gray-600 max-w-xs">
              Click the QR code to view it larger.
            </p>

            <p className="text-center text-sm mt-3 text-gray-600">
              UPI ID:{" "}
              <span className="font-semibold text-primary">9952034576m@pnb</span>
            </p>
          </div>

          {/* Member Type */}
<div>
  <label className="block text-sm font-semibold text-primary mb-2">
    Membership Type
  </label>
  <select
    name="memberType"
    value={formData.memberType}
    onChange={handleChange}
    className="w-full border border-accent/30 rounded-xl px-4 py-3 focus:ring-2 focus:ring-accent/50 outline-none"
    required
  >
    <option value="">Select Membership Type</option>
    <option value="Ordinary">Ordinary</option>
    <option value="Nominal/Associate">Nominal / Associate</option>
    
  </select>
</div>

{/* No of Shares */}
<div>
  <label className="block text-sm font-semibold text-primary mb-2">
    Number of Shares
  </label>

  <p className="text-xs font-semibold text-accent mb-2">
    Each share costs ₹100. Minimum 1 share is required to become a member.
    Registration fee: ₹100
  </p>

  <input
    type="number"
    name="no_of_shares"
    min={1}
    value={formData.no_of_shares}
    onChange={handleChange}
    placeholder="Enter number of shares"
    className="w-full border border-accent/30 rounded-xl px-4 py-3 focus:ring-2 focus:ring-accent/50 outline-none"
    required
  />

  {/* Total Amount Display */}
  <div className="mt-3 text-sm font-semibold text-primary">
    Total Amount: ₹
    {formData.no_of_shares
      ? formData.no_of_shares * 100 + 100
      : 0}
  </div>
</div>


          {/* Payment Screenshot Upload */}
          <div className="md:col-span-2">
            <label className="block text-sm font-semibold text-primary mb-2">
              Upload Payment Screenshot
            </label>

            <input
              type="file"
              accept=".jpg,.jpeg,.png,.pdf"
              onChange={(e) => setPaymentScreenshot(e.target.files[0])}
              className="w-full border border-accent/30 rounded-xl px-4 py-2 bg-white focus:ring-2 focus:ring-accent/50 outline-none"
            />
          </div>

          {/* Submit */}
          <div className="md:col-span-2 flex justify-center mt-6">
            <button
              type="submit"
              disabled={loading}
              className="px-10 py-3 bg-gradient-to-r from-accent to-amber-400 text-white font-semibold rounded-full shadow-lg hover:scale-105 transition-transform duration-300"
            >
              {loading ? "Submitting..." : "Submit Application"}
            </button>
          </div>
        </form>

        {message && (
          <p
            className={`text-center text-sm font-medium mt-2 transition-all duration-300 ${
              message.toLowerCase().includes("success")
                ? "text-green-600"
                : "text-red-600"
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </section>
  );
};

export default MembershipPage;
